import { createSlice } from '../zustandHelpers'
import { toastError } from '../../../infrastructure/hooks/useToast'
import { IDownloadsState, IDownLoadActions } from './downloads.slice.interface'

export const downloadsSlice = createSlice<IDownloadsState, IDownLoadActions>((set) => ({
  downloadData: null,
  downloadLoading: false,
  downloadError: null,

  setDownloadsData: async (downloadData) => {
    set({ downloadLoading: true, downloadError: null })
    try {
      set({ downloadData, downloadLoading: false })
    } catch (error) {
      set({ downloadLoading: false, downloadError: 'Error fetching downloads data' })
      toastError('Error fetching downloads data')
    }
  },

  cleanDownloadsData: () => {
    set({ downloadData: null, downloadError: null, downloadLoading: false })
  },
}))
